<template>
  <div>
    <populate-form
      formTitle="公休日規則設定"
      fkey="pe01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="restDayRules"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button @click="removeRestDayRule(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增店家公休日規則"
        fkey="arf01"
        ref="addForm2"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'StoreRestDayRuleManage',
  components:{
    
  },
  props: {
    'store_id':Number
  },
  data: function () {
    return {
      modalShowAdd:false,
      service_minute_unit:30,
      restDayRules:[],
      fields:[
        {
          key:'display',
          label:'規則'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-button',
          col:3,
          placeholder:"新增",
          execCallback:this.showAddRule
        },
      ],
      addData:{},
      addOptions:[
        {
          componentType:'b-form-select',
          akey:'nth_weekday',
          dataOptions:[{text:'每週',value:'0'},{text:'每個月第一個',value:'1'},{text:'每個月第二個',value:'2'},{text:'每個月第三個',value:'3'},{text:'每個月第四個',value:'4'}],
          defaultValue:'0',
          col:3,
        },
        {
          componentType:'b-form-select',
          akey:'week_day',
          dataOptions:[{text:'週日',value:'0'},{text:'週一',value:'1'},{text:'週二',value:'2'},{text:'週三',value:'3'},{text:'週四',value:'4'},{text:'週五',value:'5'},{text:'週六',value:'ˊ6'}],
          defaultValue:'0',
          col:3,
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalShowAdd = false}
            },
            {
              col:4,
              placeholder:'確認',
              execCallback:this.confirmAdd
            },
          ]
        },
      ],
    }
  },
  methods: {
    showAddRule() {
      this.addData.nth_weekday = '0'
      this.addData.week_day = '0'
      this.$refs.addForm2.refreshModelVar()
      
      this.modalShowAdd = true
    },
    removeRestDayRule(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store_admin',
          'method':'removeStoreRestdayRule',
          'store_id': this.store_id,
          'store_restday_rule_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchRestRules()
        }, this)
      })
    },
    searchRestRules() {
      let Param = {
        'module':'store_admin',
        'method':'getStoreServiceRuleByStoreId',
        'store_id': this.store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.restDayRules =data.data.rest_day_rules
      }, this)
    },
    confirmAdd() {

      let Param = {
        'module':'store_admin',
        'method':'addStoreRestdayRule',
        'store_id': this.store_id,
        'nth_weekday':this.addData.nth_weekday,
        'week_day':this.addData.week_day,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm2.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchRestRules()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("添加設定成功")
        vm.modalShowAdd = false
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    /*if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
        vm.restDayRules = data.data.rest_day_rules
      }, this)
    }*/
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.searchRestRules()
      this.$refs.addForm2.initDefault()
      
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
